import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectFoundersReportParams } from '@/shared/api/end-points/project'
import { FoundersReportResponse } from '../../lib'

const getFoundersReport = async (params: GetProjectFoundersReportParams) => {
  return await api.json<FoundersReportResponse>(API_END_POINTS.project.getProjectFoundersReport(params))
}

export default getFoundersReport
